import React from 'react'
import {
    Box,
    Link,
    Typography,
} from "@mui/material";

const Copyright = () => {
    return ( 
        <Box sx={{p:3, textAlign:'center'}}>
            <Typography variant="h6">©2025 by <Link href="">Clio Research Inc.</Link></Typography>
        </Box>
     );
}
export default Copyright;